const ROOT = '/call-sheets';

const routes = {
  list: () => ROOT,
  item: (id) => `${ROOT}/${id}`
};

export default routes;
